import {
  Button,
  Dialog,
  DialogContent,
  Grid,
  makeStyles,
  Typography,
} from '@material-ui/core';
import React, { useRef, useState, useEffect } from 'react';
import { Trash2 } from 'react-feather';
import { connect } from 'react-redux';
import Loading from '../../../shared/componentes/Loading';
import {
  informacoesModais,
  iconesNotificacao,
  noficacaoMensagemWhatsappRemovida,
} from '../../../shared/util/Constantes';
import {
  exibirNotificacaoAlerta,
  exibirNotificacaoSucesso,
} from '../../notificacao/Store';
import {
  WHITE,
  BLACK,
  DARK_CYAN,
  FONT_FAMILY_BOLD,
  FONT_FAMILY_REGULAR,
  MEDIUM_GRAY,
  TOMATO,
  TOMATO_HOVER,
} from '../../../theme';
import GestaoMensagensManager from '../GestaoMensagensManager';

const useStyles = makeStyles(() => ({
  botaoEsquerdo: {
    color: MEDIUM_GRAY,
    fontWeight: 'bold',
    fontSize: '14px',
    padding: '16px 26px',
  },
  titulo: {
    color: DARK_CYAN,
    fontWeight: 'bold',
    fontSize: '18px',
    marginBottom: '25px',
  },
  botaoDireito: {
    color: WHITE,
    backgroundColor: TOMATO,
    fontFamily: FONT_FAMILY_BOLD,
    fontSize: '14px',
    lineHeight: '52px',
    padding: '0px 26px',
    '&:hover': {
      backgroundColor: TOMATO_HOVER,
    },
  },
  backgroundProps: {
    background: 'rgba(192,198,214,0.4)',
  },
  modal: {
    maxWidth: '400px',
    backgroundColor: WHITE,
    boxShadow: '0 2px 38px 0 rgba(0,0,0,0.07), 0 9px 15px 0 rgba(0,0,0,0.05)',
    borderRadius: '8px',
    minWidth: '350px',
  },
  containerConteudoDialog: {
    padding: '20px 15px 20px 15px',
  },
  aviso: {
    fontSize: '16px',
    color: TOMATO,
    fontFamily: FONT_FAMILY_REGULAR,
    marginBottom: '20px',
  },
  descricao: {
    fontSize: '16px',
    color: BLACK,
    fontFamily: FONT_FAMILY_REGULAR,
    marginBottom: '20px',
  },
  closeButton: {
    position: 'absolute',
    right: '16px',
    top: '16px',
    color: '#9e9e9e',
  },
}));

const ModalExclusaoWhatsappMensagem = (props) => {
  const {
    modalAberto,
    setModalAberto,
    notificarSucesso,
    idMensagem,
    handleExclusao,
  } = props;
  const classes = useStyles();

  const [carregando, setCarregando] = useState(false);
  const isUmounted = useRef(false);

  const handleOnCloseAsync = async () => {
    if (!carregando) await setModalAberto(false);
  };

  const excluirMensagem = async () => {
    setCarregando(true);
    const result = await GestaoMensagensManager.deletarMensagemWhatsapp(
      idMensagem
    );
    if (result && result.Message === noficacaoMensagemWhatsappRemovida) {
      notificarSucesso(
        'Mensagem excluída com sucesso',
        iconesNotificacao.Exclusao
      );
      handleExclusao(idMensagem);
    }
    setModalAberto(false);

    if (isUmounted.current) {
      setCarregando(false);
    }
  };

  useEffect(() => {
    isUmounted.current = true;
    return () => {
      isUmounted.current = false;
    };
  }, []);

  return (
    <Dialog
      open={modalAberto}
      onClose={handleOnCloseAsync}
      aria-labelledby="modal-titulo"
      aria-describedby="modal-descricao"
      data-testid="modal-confirm-dialog"
      scroll="body"
      classes={{ paper: classes.modal }}
      BackdropProps={{
        classes: {
          root: classes.backgroundProps,
        },
      }}
    >
      {carregando && <Loading />}
      <DialogContent>
        <Grid
          container
          direction="row"
          spacing={2}
          className={classes.containerConteudoDialog}
        >
          <Typography className={classes.titulo}>
            {informacoesModais.ModalExcluirMensagensWhatsapp.titulo}
          </Typography>
          <Grid>
            <Typography className={classes.aviso}>
              {informacoesModais.ModalExcluirMensagensWhatsapp.aviso}
            </Typography>
            <Typography className={classes.descricao}>
              {informacoesModais.ModalExcluirMensagensWhatsapp.descricao}
            </Typography>
          </Grid>
          <Grid
            container
            direction="row"
            justifyContent="space-around"
            alignItems="center"
          >
            <Button
              className={classes.botaoEsquerdo}
              onClick={() => setModalAberto(!modalAberto)}
            >
              {
                informacoesModais.ModalExcluirMensagensWhatsapp
                  .textoBotaoEsquerdo
              }
            </Button>
            <Button
              className={classes.botaoDireito}
              disableElevation
              startIcon={<Trash2 size={20} />}
              onClick={excluirMensagem}
            >
              {
                informacoesModais.ModalExcluirMensagensWhatsapp
                  .textoBotaoDireito
              }
            </Button>
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  );
};

export const mapStateToProps = () => ({});

const mapDispatchToProps = {
  notificarSucesso: exibirNotificacaoSucesso,
  notificarAlerta: exibirNotificacaoAlerta,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ModalExclusaoWhatsappMensagem);
